var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('reusable-dialog', {
    model: {
      value: _vm.isVisibleDialog,
      callback: function callback($$v) {
        _vm.isVisibleDialog = $$v;
      },
      expression: "isVisibleDialog"
    }
  }, [_c('h3', {
    attrs: {
      "slot": "title"
    },
    domProps: {
      "textContent": _vm._s(_vm.$t('bill.tips.edit.variants.title'))
    },
    slot: "title"
  }), _c('input-text', {
    directives: [{
      name: "m-t",
      rawName: "v-m-t",
      value: 0,
      expression: "0"
    }, {
      name: "overflow",
      rawName: "v-overflow:hidden",
      arg: "hidden"
    }],
    ref: "tipsVariants",
    attrs: {
      "input-id": "tips-variants",
      "input-title": _vm.$t('enter.variants'),
      "input-name": _vm.$t('bill.tips.variant.label'),
      "input-placeholder": _vm.$t('bill.tips.variant.label'),
      "formatter": _vm.tipsFormatter,
      "required": false
    },
    on: {
      "change": function change($event) {
        _vm.tipsVariants = $event;
      }
    },
    scopedSlots: _vm._u([{
      key: "tooltip",
      fn: function fn(_ref) {
        var focus = _ref.focus;
        return [_c('responsive-controller', {
          scopedSlots: _vm._u([{
            key: "tablet",
            fn: function fn() {
              return [_c('base-icon', {
                directives: [{
                  name: "color",
                  rawName: "v-color",
                  value: focus ? '#2F80ED' : 'white',
                  expression: "focus ? '#2F80ED' : 'white'"
                }, {
                  name: "cursor",
                  rawName: "v-cursor:pointer",
                  arg: "pointer"
                }],
                attrs: {
                  "name": "notifications_question-circle"
                },
                on: {
                  "click": _vm.handleAlert
                }
              })];
            },
            proxy: true
          }, {
            key: "default",
            fn: function fn() {
              return [_c('base-icon', {
                directives: [{
                  name: "color",
                  rawName: "v-color",
                  value: focus ? '#2F80ED' : 'white',
                  expression: "focus ? '#2F80ED' : 'white'"
                }, {
                  name: "cursor",
                  rawName: "v-cursor:pointer",
                  arg: "pointer"
                }],
                attrs: {
                  "name": "notifications_question-circle",
                  "title": _vm.$t('bill.tips.variant.tooltip')
                }
              })];
            },
            proxy: true
          }], null, true)
        })];
      }
    }]),
    model: {
      value: _vm.tipsVariants,
      callback: function callback($$v) {
        _vm.tipsVariants = $$v;
      },
      expression: "tipsVariants"
    }
  }), _c('simple-button', {
    attrs: {
      "slot": "submit",
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSubmit
    },
    slot: "submit"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.apply')) + " ")]), _c('simple-button', {
    attrs: {
      "slot": "cancel",
      "variant": "transparent"
    },
    on: {
      "click": function click($event) {
        _vm.isVisibleDialog = false;
      }
    },
    slot: "cancel"
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }